module.exports = __webpack_public_path__ + "static/polco-724c2440297a4e0b81e51fcfa8cc3565.mp4";